export const LEVEL_CHANGES = "levelChanges";
